import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import { useDispatch, useSelector } from 'react-redux';
import {selectors, setParticipantCountGroup} from '../../features/schools/slice';

const ALL_VALUE = 5;

const IndexValueMap = [
  '0',
  '1',
  '2-9',
  '10-20',
  '>20',
  'Visi',
];

const useStyles = makeStyles((theme) => ({
    formControl: {
      margin: theme.spacing(1),
      minWidth: 120,
    },
    selectEmpty: {
      marginTop: theme.spacing(2),
    },
  }));

const yearFilter = () => {

    const classes = useStyles();

    const partCount = useSelector(selectors.participantCountGroupsIndx);

    const dispatch = useDispatch();

    const handleChange = (event) => {

        let values = event.target.value;

        if(values.includes(ALL_VALUE) && !partCount.includes(ALL_VALUE)) {
          values = [0,1,2,3,4,5];
        } else if (!values.includes(ALL_VALUE) && partCount.length === IndexValueMap.length) {
          values = [];
        } else if (partCount.includes(ALL_VALUE) && values.length === IndexValueMap.length-1 && partCount.length === IndexValueMap.length) {

          const valueActive = partCount.filter(x=>!values.includes(x));
          values = valueActive;
        }
         else if (partCount.includes(ALL_VALUE) && values.length < IndexValueMap.length) {
          values.splice(values.indexOf(ALL_VALUE), 1);
        }

        dispatch(setParticipantCountGroup(values));
    }

    const renderValue = (values, arg2) => {

      if(values.includes(ALL_VALUE)) {
        values = [ALL_VALUE];
      }

      return (<div>{values.map((value, i)=>((i > 0 ? ', ' : '')+IndexValueMap[value]))}</div>)
    }
    
    return <FormControl className={classes.formControl}>
    <InputLabel id="yearFilter">Kārtotāju skaits</InputLabel>
    <Select
      renderValue={renderValue}
      labelId="yearFilter-label"
      id="yearFilter-helper"
      value={partCount}
      onChange={handleChange}
      multiple
    >
      <MenuItem value={5}>{IndexValueMap[5]}</MenuItem>
      <MenuItem value={0}>{IndexValueMap[0]}</MenuItem>
      <MenuItem value={1}>{IndexValueMap[1]}</MenuItem>
      <MenuItem value={2}>{IndexValueMap[2]}</MenuItem>
      <MenuItem value={3}>{IndexValueMap[3]}</MenuItem>
      <MenuItem value={4}>{IndexValueMap[4]}</MenuItem>
    </Select>
    <FormHelperText>Eksāmena kārtotāja skaita iedalījums</FormHelperText>
  </FormControl>
}

export default yearFilter;


// WEBPACK FOOTER //
// ./C:/Users/viesis/Desktop/letera/src/components/filters/participantCount.js